import * as React from "react"

function ShareOfDigitalShelf(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 350" {...props}>
      <style>
        {
          ".share-of-digital-shelf_st2{fill:#00aeef}.share-of-digital-shelf_st3{fill:#fff}.share-of-digital-shelf_st4{fill:#e9ecef}.share-of-digital-shelf_st5{fill:#c1c6cb}.share-of-digital-shelf_st7{fill:#edc9c9}.share-of-digital-shelf_st8{fill:#d99596}.share-of-digital-shelf_st9{fill:#97a3e3}.share-of-digital-shelf_st10{fill:#8fddfd}.share-of-digital-shelf_st11{fill:#79c5a8}.share-of-digital-shelf_st12{fill:#7fb3be}.share-of-digital-shelf_st16{fill:#f9f5f9}.share-of-digital-shelf_st18{fill:#f8ece9}.share-of-digital-shelf_st23{fill:#f2eddc}.share-of-digital-shelf_st25{fill:#ebebda}.share-of-digital-shelf_st26{fill:#eee9d5}.share-of-digital-shelf_st27{fill:#e8ecdd}.share-of-digital-shelf_st32{fill:#4abfef}.share-of-digital-shelf_st33{fill:#57d3a2}.share-of-digital-shelf_st34{fill:#f1d060}.share-of-digital-shelf_st35{fill:#f2bb6e}.share-of-digital-shelf_st36{fill:#caafe7}"
        }
      </style>
      <g id="share-of-digital-shelf_Guides_and_Back">
        <path
          className="share-of-digital-shelf_st2"
          d="M566.1 297.5c-33.7 38.7-88.7 8.5-228.1 13.7-181.8 6.8-231.6 63.6-277.6 26.1-75.7-62-33.3-292.3 61.3-325.2C147.8 3 162.3 14.5 224 32.3c183.8 53.1 247.1 7 308.2 63.9 56.4 52.4 72.5 156.9 33.9 201.3z"
        />
        <path className="share-of-digital-shelf_st3" d="M50 50h500v250H50z" />
      </g>
      <g id="share-of-digital-shelf_Page_Content">
        <path
          className="share-of-digital-shelf_st3"
          d="M86.2 92.5c-2 0-3.7-1.7-3.7-3.7V72.3c0-2 1.7-3.7 3.7-3.7h178.6c2 0 3.7 1.7 3.7 3.7v16.6c0 2-1.7 3.7-3.7 3.7H86.2z"
        />
        <path
          className="share-of-digital-shelf_st4"
          d="M264.8 69c1.8 0 3.2 1.4 3.2 3.2v16.6c0 1.8-1.4 3.2-3.2 3.2H86.2c-1.8 0-3.2-1.4-3.2-3.2V72.3c0-1.8 1.4-3.2 3.2-3.2h178.6m0-1.1H86.2c-2.3 0-4.2 1.9-4.2 4.2v16.6c0 2.3 1.9 4.2 4.2 4.2h178.6c2.3 0 4.2-1.9 4.2-4.2V72.3c0-2.4-1.9-4.3-4.2-4.3z"
        />
        <path className="share-of-digital-shelf_st5" d="M92.3 75.8H176v8.6H92.3z" />
        <path
          d="M295 93h-22c-2.2 0-4-1.8-4-4V72c0-2.2 1.8-4 4-4h22c2.2 0 4 1.8 4 4v17c0 2.2-1.8 4-4 4z"
          fill="#1eca8a"
        />
        <path
          className="share-of-digital-shelf_st2"
          d="M326.8 83l-1.6-.9c.2-.9.2-1.8 0-2.6l1.6-.9c.2-.1.3-.3.2-.5-.4-1.3-1.1-2.5-2.1-3.6-.1-.2-.4-.2-.6-.1l-1.6.9c-.7-.6-1.4-1-2.3-1.3v-1.8c0-.2-.1-.4-.4-.4-1.4-.3-2.8-.3-4.1 0-.2 0-.4.2-.4.4V74c-.8.3-1.6.7-2.3 1.3l-1.6-.9c-.2-.1-.4-.1-.6.1-.9 1-1.6 2.2-2.1 3.6-.1.2 0 .4.2.5l1.6.9c-.2.9-.2 1.8 0 2.6l-1.6.9c-.2.1-.3.3-.2.5.4 1.3 1.1 2.5 2.1 3.6.1.2.4.2.6.1l1.6-.9c.7.6 1.4 1 2.3 1.3v1.8c0 .2.1.4.4.4 1.4.3 2.8.3 4.1 0 .2 0 .4-.2.4-.4v-1.8c.8-.3 1.6-.7 2.3-1.3l1.6.9c.2.1.4.1.6-.1.9-1 1.6-2.2 2.1-3.6.1-.2 0-.4-.2-.5zm-8.7.7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
        />
        <path
          className="share-of-digital-shelf_st4"
          d="M86 281.5c-1.9 0-3.5-1.6-3.5-3.5V107c0-1.9 1.6-3.5 3.5-3.5h428.1c1.9 0 3.5 1.6 3.5 3.5v171c0 1.9-1.6 3.5-3.5 3.5H86z"
        />
        <path
          className="share-of-digital-shelf_st4"
          d="M514.1 104c1.7 0 3 1.3 3 3v171c0 1.7-1.3 3-3 3H86c-1.7 0-3-1.3-3-3V107c0-1.7 1.3-3 3-3h428.1m0-1H86c-2.2 0-4 1.8-4 4v171c0 2.2 1.8 4 4 4h428.1c2.2 0 4-1.8 4-4V107c0-2.2-1.8-4-4-4z"
        />
        <path className="share-of-digital-shelf_st5" d="M92.3 111.7H157v8.6H92.3z" />
        <path className="share-of-digital-shelf_st2" d="M90.8 130.2H156V274H90.8z" />
        <path
          className="share-of-digital-shelf_st3"
          d="M94.3 135.7H136v8.6H94.3zM94.3 151.9H148v6.3H94.3zM94.3 161.9H143v6.3H94.3zM94.3 171.9H148v6.3H94.3zM94.3 181.9H146v6.3H94.3zM94.3 191.9H127v6.3H94.3z"
        />
        <path
          className="share-of-digital-shelf_st7"
          d="M365.3 195c-.2 5.7-.9 11.2-2.6 16.7-1.4 4.6-3.4 8.9-5.9 13-2.8 4.6-6.1 8.8-10.1 12.4-3.2 2.9-6.7 5.4-10.4 7.6-6.2 3.6-12.9 5.8-19.9 6.9-1.8.3-3.7.3-5.6.5-2.5.3-4.9 0-7.4-.1-3.5-.2-7-.8-10.4-1.8-4.4-1.2-8.6-2.9-12.6-5.1-3.7-2-7.2-4.5-10.4-7.3-5-4.3-8.9-9.3-12.1-15l-.4-.4c-.2-.6.3-.7.6-.9 1.2-.8 2.6-1.4 3.9-2.1 6.5-3.5 12.9-7 19.4-10.5 6.4-3.4 12.7-6.9 19.1-10.3 2.1-1.2 4.3-2.3 6.4-3.5.6-.4 1.3-.6 2.1-.6h55.2c.4.3.8.2 1.1.5z"
        />
        <path
          className="share-of-digital-shelf_st8"
          d="M271.1 150.5c4-3.2 8.3-5.9 13-8.1.5-.2 1-.5 1.5-.6.1-.1.3-.2.4-.2.9-.4 1.2.2 1.5.9 1.6 4.1 3.2 8.2 4.8 12.2 4.1 10.3 8.1 20.7 12.2 31 .8 2 1.6 4 2.3 5.9.2.4.4.9.2 1.4-.4.4-.6-.1-.8-.3-1.5-1.6-2.8-3.3-4.2-4.9-2.9-3.4-5.7-6.8-8.6-10.2-2.9-3.4-5.7-6.8-8.6-10.2-2.9-3.4-5.7-6.8-8.6-10.2-1.6-1.8-3.2-3.7-4.7-5.6-.3-.2-.8-.5-.4-1.1z"
        />
        <path
          className="share-of-digital-shelf_st9"
          d="M259.4 163.7c1.3-1.8 2.5-3.6 3.9-5.2 1.7-2 3.4-4.1 5.4-5.7.5-.4.9-.9 1.3-1.3.5-.5.9-.4 1.4.2 2.5 3 5 5.9 7.5 8.9 2.8 3.4 5.7 6.7 8.5 10.1 2.4 2.9 4.9 5.8 7.3 8.7 2.8 3.4 5.7 6.7 8.5 10.1.8 1 1.6 1.9 2.4 2.9.2.2.4.4.4.7 0 .2-.1.3-.3.3-.4 0-.8-.2-1.2-.4-7.5-4.7-15.1-9.5-22.6-14.2-7.3-4.6-14.5-9.2-21.8-13.7-.4-.5-1.1-.6-.7-1.4z"
        />
        <path
          className="share-of-digital-shelf_st10"
          d="M253.3 176.4c1.1-3 2.3-5.9 3.8-8.7.5-1 1.1-2 1.6-3 .3-.6.7-.4 1.1-.1 2.9 1.8 5.8 3.6 8.8 5.5 9.2 5.7 18.3 11.5 27.5 17.2 3.1 1.9 6.1 3.9 9.2 5.8.2.1.7.2.4.7-.5.2-1-.1-1.4-.2-8.7-2.9-17.5-5.8-26.3-8.6-7.8-2.6-15.6-5.2-23.5-7.7-.4-.1-1.1-.1-1.2-.9z"
        />
        <path
          className="share-of-digital-shelf_st11"
          d="M250.6 189.4c-.2-.9.2-1.7.3-2.6.3-2.9 1-5.7 1.8-8.4.1-.1.1-.3.1-.4.3-1.2.3-1.2 1.5-.8l21.9 7.2c9.1 3 18.2 6 27.4 9 .4.1.9.2 1.2.6 0 .1 0 .2-.1.3-.3.2-.7.2-1 .2-.3 0-.7 0-1-.1-.5-.2-1.1-.1-1.7-.1-.2 0-.4 0-.7-.1-.5-.2-1.1-.1-1.6-.1-.4-.1-.8-.2-1.3-.2h-1.2c-.1 0-.2 0-.3-.1-.5-.2-1.1-.1-1.6-.1-.2 0-.4 0-.7-.1-.5-.2-1.1-.1-1.7-.1-1.7-.1-3.3-.4-4.9-.5-.6-.2-1.2-.1-1.9-.2-.8-.3-1.8.2-2.6-.3-.6-.2-1.2-.1-1.8-.1-.2 0-.3 0-.5-.1-.6-.2-1.2-.1-1.9-.1-.8 0-1.6-.3-2.4-.3-.6-.2-1.3-.1-1.9-.2-.2 0-.3 0-.5-.1-.6-.2-1.2-.1-1.9-.1-.8 0-1.6-.3-2.4-.3-.6-.2-1.3-.1-1.9-.1-.3 0-.7 0-1-.1-.4-.2-.9-.1-1.3-.1-.8 0-1.6-.3-2.3-.3-.4-.1-.8-.2-1.3-.1-.4.1-.9.1-1.3-.1s-.9-.1-1.3-.1c-1.2 0-2.3-.3-3.5-.3-.4-.2-.9-.2-1.4-.1-1.1-.3-2.3.2-3.3-.5z"
        />
        <path
          className="share-of-digital-shelf_st12"
          d="M257.2 221.9l-.4-.4c-1.4-2.5-2.4-5.1-3.4-7.7-.2-.4.1-.6.3-.8.3-.2.6-.3 1-.4 6.4-2.1 12.8-4.3 19.3-6.5 7.7-2.6 15.3-5.2 23-7.8 1.8-.6 3.6-1.3 5.4-1.9.4-.1.7-.3 1.1-.2.2 0 .3.1.3.3-.4.8-1.2.9-1.8 1.3-6.6 3.5-13.1 7.1-19.6 10.6l-15.6 8.4c-2.9 1.6-5.9 3.1-8.8 4.8-.2.3-.4.4-.8.3z"
        />
        <path
          d="M257.2 221.9c7-3.8 14.1-7.6 21.1-11.4l25.5-13.8c.2-.4.7-.5 1-.7.3-.2.6-.4 1-.5.5-.2.9-.5 1.2-1 .1-.1.3-.2.5-.3h.3c.2 0 .3.1.5.2s.4 0 .6 0h53.7c2.8 0 2.6.3 2.4-2.5-.3-7-1.9-13.6-4.8-20-2.2-4.9-5-9.4-8.4-13.5-2.2-2.7-4.7-5.1-7.3-7.3-.5-.4-1.1-.7-1.3-1.3 0-.1 0-.2.1-.3 2.9 2.1 5.4 4.5 7.8 7.2 2.3 2.6 4.4 5.4 6.2 8.4 3.4 5.6 5.8 11.6 7.1 18 .6 2.7.9 5.4 1.1 8.2 0 .9.3 1.8.2 2.7 0 .5 0 .9-.4 1.2H309c-.8 0-1.5.2-2.2.6-4.4 2.4-8.9 4.8-13.3 7.2-7.3 4-14.6 7.9-21.9 11.9-4.1 2.2-8.3 4.4-12.4 6.6-.7.3-1.4.6-1.8 1.3-.2-.3-.1-.6-.2-.9z"
          fill="#fdfcfc"
        />
        <path
          d="M308.5 194.6c-.2 0-.3 0-.4-.2-.2-.3-.3-.6 0-.9.5-.2.7-.7 1-1.1 8.7-11.6 17.4-23.1 26.1-34.7 2-2.6 4-5.3 6-7.9.7-1 .7-1-.3-1.7-4.8-3.5-10.1-6.1-15.8-7.9-3.4-1.1-6.8-1.8-10.3-2.2-.3 0-.6 0-.9-.2-.1-.2-.1-.3.1-.4 5.5.6 10.8 1.8 15.9 4 4.9 2 9.4 4.6 13.6 7.9v.2c-.6.1-1.1.4-1.5.9-8.9 12-17.9 23.8-26.9 35.8-1.9 2.5-3.8 5-5.7 7.6-.4.3-.6.6-.9.8z"
          fill="#b9ecdf"
        />
        <path
          d="M313.9 137.4v.4c.3.4.3.8.2 1.2-.8 7.7-1.6 15.3-2.4 23-.7 7.1-1.5 14.2-2.2 21.4-.3 3-.6 6.1-1 9.1-.1.4 0 .8-.4 1-.2.2-.1.6-.2.9-.1-.1-.3-.2-.4-.2-.1-.1-.2-.3-.2-.5 1-10.5 2.2-21 3.2-31.6.8-7.6 1.6-15.3 2.4-22.9.1-1.1.1-1.2-1-1.3-6.4-.6-12.6 0-18.8 1.7-2.1.5-4.1 1.1-6 2-.5-.1-.4-.3-.2-.7 4.2-1.7 8.6-2.8 13.1-3.4 2.6-.4 5.2-.6 7.8-.5 2 .1 4.1 0 6.1.4z"
          fill="#f1ebc0"
        />
        <path
          className="share-of-digital-shelf_st16"
          d="M307.2 194.4c-.2.6-.7.9-1.3 1.3-.1-.1-.2-.1-.4-.2-.4 0-.8.1-1.2.2-7.8 1.1-15.5 2-23.3 2.9-9.5 1.2-19 2.4-28.5 3.5-1.3.2-1.4.3-1.2 1.6.4 2.4.9 4.7 1.6 7 .2.6.4 1.2.4 1.8 0 .2-.1.4-.2.5-1.1-3-1.8-6.1-2.3-9.2-.1-.8-.1-1.6-.4-2.3.1-.1.3-.2.5-.3 9.2-1.2 18.5-2.3 27.8-3.4 7.1-.9 14.2-1.7 21.3-2.6 1.6-.2 3.2-.4 4.9-.5.5-.1 1-.1 1.6 0 .1 0 0-.2 0-.1s0 .1-.1.1c-.2 0-.4-.1-.3-.4.3-.1.7-.5 1.1.1z"
        />
        <path
          d="M253.1 213v-.4c.7 0 1.4-.1 2-.4 9-3.1 18-6.1 27.1-9.2 7.1-2.4 14.1-4.9 21.2-7.2.4-.1.9-.2 1.3-.3.4-.1.7-.4 1.1-.1l.2.2c-.4.1-.7.3-1.1.4-.4.2-.8.3-1.2.4-8.8 3-17.6 5.9-26.3 8.9-7.6 2.6-15.2 5.2-22.9 7.8-.7.2-.9.4-.6 1.3.9 2.5 2.1 4.7 3.1 7.2-1-.8-1.1-2-1.6-3.1-1.1-1.7-1.8-3.6-2.3-5.5z"
          fill="#ecf2f5"
        />
        <path
          className="share-of-digital-shelf_st18"
          d="M286.9 140.9c0 .2 0 .5.2.6.6.2.7.8.8 1.2 3.5 8.9 7 17.9 10.5 26.8 2.9 7.5 5.9 15 8.8 22.5.2.5.4 1 .3 1.6v.5c-.3.1-.5-.2-.7-.4-.1-.2-.3-.4-.1-.7-.1-1.6-1-3-1.6-4.5-4.6-11.9-9.3-23.8-14-35.7-1.4-3.5-2.8-7.1-4.2-10.6-.2-.6-.5-.8-1.1-.7.4-.2.8-.4 1.1-.6z"
        />
        <path
          d="M306.8 193.1c.1.2.1.4.2.6 0 .5-.3.3-.5.2-.2-.3-.4-.7-.6-1-3.5-4.1-6.9-8.2-10.4-12.3l-9.6-11.4c-2.9-3.4-5.8-6.8-8.6-10.1-2.1-2.4-4.1-4.9-6.1-7.3-.4-.5-.7-.6-1.2-.3.2-.5.6-.7 1.1-.8.2 1 1.1 1.6 1.7 2.3 3.2 3.8 6.5 7.6 9.7 11.4 3.2 3.8 6.3 7.5 9.5 11.3 2.4 2.8 4.7 5.6 7.1 8.4 2.5 3 5.1 6 7.7 9z"
          fill="#e8e7f4"
        />
        <path
          d="M304.7 194c-5.8-1.9-11.7-3.9-17.5-5.8-11-3.6-22.1-7.2-33-10.9-1.3-.4-1.1.6-1.5 1.1 0-.7.1-1.4.6-1.9.9.7 2 .8 3.1 1.2 6.5 2.2 13 4.3 19.5 6.4 9.7 3.2 19.3 6.3 29 9.5.3.1.6.1.9.2.1-.1.3-.1.4 0 .1.2-.1.3-.2.4-.1.1-.2.1-.3.1-.5.1-.8 0-1-.3z"
          fill="#def1ee"
        />
        <path
          d="M305.8 194.2c-.1-.1.6-.3 0-.4-3-1.9-6.1-3.9-9.1-5.8-10.9-6.8-21.8-13.7-32.7-20.5-1.4-.9-2.8-1.7-4.2-2.7-.4-.2-.7-.3-1 0 0-.5.2-.9.6-1.1 0 .4.3.6.6.8 9.1 5.7 18.3 11.4 27.4 17.2 5.6 3.5 11.2 7 16.8 10.6.5.3 1.1.6 1.6 1 .4.1.7.3.9.6.1.2.3.2.4 0 .2.1.4.3.6.4-.1.2-.2.2-.4.2h-1.2c-.3-.1-.3-.2-.3-.3z"
          fill="#e8f6fd"
        />
        <path
          d="M305.8 194.2l.2.2c.1.3.4.1.7.4-.6.1-1.1 0-1.6.2-.9-.4-1.9-.1-2.9-.2-5.5-.5-11.1-1-16.6-1.6-7.1-.7-14.1-1.3-21.2-2-4.1-.4-8.2-.8-12.3-1.1-1.2-.1-1.2-.1-1.3 1.1-.2 2.4-.2 4.9 0 7.3.1 1 .4 2 0 3h-.4c.2-.6-.3-1.1 0-1.7-.2-.3 0-.7-.2-1.1v-1.3c-.2-.5 0-1-.1-1.5.1-.7-.1-1.4.1-2.1v-3.1c.3-.4 0-.9.2-1.3.1-.1.2-.1.3-.2 1.1.1 2.2.2 3.3.2.4.3.9 0 1.3.2 1.3-.1 2.5.3 3.8.2.4.2.9 0 1.3.2.3 0 .7.3 1 0 .4.2.9 0 1.3.2.8.1 1.6.1 2.5.2.4.3.9 0 1.3.2h1c.6.3 1.3-.1 1.9.2.8.1 1.6.1 2.5.2.6.3 1.3-.1 1.9.2h.4c.6.3 1.3-.1 1.9.2.8.1 1.6.1 2.5.2.6.3 1.3-.1 1.9.2h.4c.6.3 1.3-.1 1.9.2.8.4 1.7-.2 2.5.2.6.3 1.3-.1 1.9.2 1.7 0 3.3.3 5 .4.5.3 1.2 0 1.7.2h.6c.5.3 1.2-.1 1.7.2h.2c.4.2.8.1 1.2 0 .4-.1.9.1 1.3.2.5.3 1.2 0 1.7.2h.6c.5.3 1.2-.1 1.7.2h1c.4.2.8.1 1.2 0 .1.4.4.6.7.4z"
          fill="#efe8d2"
        />
        <path
          className="share-of-digital-shelf_st23"
          d="M250.1 194v2.1c-.1.1-.1.1-.2 0 .1-.7-.2-1.4.2-2.1z"
        />
        <path
          className="share-of-digital-shelf_st18"
          d="M285.5 141.8c-.4.3-.9.6-1.5.6.4-.4.9-.7 1.5-.6z"
        />
        <path
          className="share-of-digital-shelf_st16"
          d="M249.9 196.1h.2v1.4c-.4-.4-.1-.9-.2-1.4z"
        />
        <path
          className="share-of-digital-shelf_st23"
          d="M250.3 189.6c0 .4.2.9-.2 1.3.1-.5-.1-.9.2-1.3zM250.1 198.8c.3.3.2.7.2 1.1-.3-.3-.1-.7-.2-1.1z"
        />
        <path
          d="M306.6 193.8c-.3-.2-.7-.3-.9-.6l.2-.2c.4.1.7.4.7.8z"
          fill="#b0bbe9"
        />
        <path
          className="share-of-digital-shelf_st25"
          d="M269.2 191.1c-.6-.1-1.3.2-1.9-.2.6 0 1.3-.2 1.9.2zM273.6 191.5c-.6-.1-1.3.2-1.9-.2.6.1 1.3-.2 1.9.2zM275.9 191.7c-.6-.1-1.3.2-1.9-.2.6.1 1.3-.2 1.9.2z"
        />
        <path
          className="share-of-digital-shelf_st26"
          d="M280.3 192.1c-.6-.1-1.3.2-1.9-.2.6.1 1.3-.2 1.9.2zM282.6 192.3c-.6-.1-1.3.2-1.9-.2.6.1 1.3-.2 1.9.2zM287 192.7c-.6-.1-1.3.2-1.9-.2.6.1 1.3-.1 1.9.2z"
        />
        <path
          className="share-of-digital-shelf_st27"
          d="M293.7 193.4c-.6-.1-1.2.2-1.7-.2.5 0 1.1-.2 1.7.2zM296 193.6c-.6-.1-1.2.2-1.7-.2.5 0 1.1-.2 1.7.2zM300.4 194c-.6-.1-1.2.2-1.7-.2.5 0 1.1-.2 1.7.2zM302.7 194.2c-.6-.1-1.2.2-1.7-.2.5.1 1.1-.2 1.7.2z"
        />
        <path
          d="M305.7 194.2c-.2.3-.5.2-.8.2-.1-.1-.2-.1-.2-.2v-.2c.3.1.7.2 1 .2z"
          fill="#9ed4be"
        />
        <path d="M304.7 194.2l.2.2c-.4-.1-.9.2-1.3-.2h1.1z" fill="#e6ebdb" />
        <path
          className="share-of-digital-shelf_st27"
          d="M260.2 190.2c-.4 0-.9.2-1.3-.2.5.1.9-.1 1.3.2zM262.5 190.4c-.4 0-.9.2-1.3-.2.5.1.9-.1 1.3.2z"
        />
        <path
          className="share-of-digital-shelf_st23"
          d="M266.3 190.9c-.4-.1-.9.2-1.3-.2.4 0 .9-.2 1.3.2z"
        />
        <path d="M297.4 193.6c-.4.3-.8.3-1.2 0h1.2z" fill="#f1eede" />
        <path
          className="share-of-digital-shelf_st23"
          d="M255.2 189.8c-.4-.1-.9.2-1.3-.2.4.1.9-.2 1.3.2z"
        />
        <path
          d="M303.6 196.5c.4-.3.8-.4 1.2-.4-.3.3-.7.4-1 .6 0-.1-.1-.1-.2-.2z"
          fill="#a8cad2"
        />
        <path
          className="share-of-digital-shelf_st32"
          d="M308.5 194.6c.9-1.7 2.2-3.2 3.4-4.7 5.6-7.5 11.3-15 17-22.6 4.4-5.8 8.8-11.6 13.2-17.5.5-.6.8-.7 1.4-.4 1.8 1.6 3.7 3.1 5.4 4.9 8.5 8.8 13.8 19.2 15.9 31.2.5 2.7.7 5.4.7 8.2 0 .7-.2.9-.9.9h-56.1z"
        />
        <path
          className="share-of-digital-shelf_st33"
          d="M308.2 193.6c.4-4 .8-8 1.3-12 .4-3.7.7-7.4 1.1-11.1.5-4.4 1-8.8 1.4-13.1l.9-9.6c.3-3.3.7-6.6 1-9.9 1.9 0 3.6.4 5.4.7 6.9 1.4 13.3 4 19.3 7.8 1 .6 1.9 1.3 2.8 1.9.7.4.6.8.2 1.3l-9 12-23.7 31.5c-.2.2-.2.7-.7.5z"
        />
        <path
          className="share-of-digital-shelf_st34"
          d="M307.7 193.7l-7.5-19.2c-2.9-7.3-5.7-14.7-8.6-22-1.4-3.7-2.9-7.4-4.4-11 0-.4.4-.5.6-.6 4.3-1.6 8.7-2.7 13.3-3.2 3.1-.4 6.2-.4 9.4-.4.8 0 1.7.1 2.5.2.7 0 .6.5.5.9-.2 2.2-.5 4.5-.7 6.7-.3 2.4-.5 4.8-.8 7.2-.3 3.1-.7 6.2-1 9.3-.2 2.3-.5 4.6-.7 6.9-.3 3.1-.7 6.1-1 9.2-.2 2.3-.4 4.6-.7 6.9-.3 3.2-.4 6.2-.9 9.1z"
        />
        <path
          className="share-of-digital-shelf_st35"
          d="M250.8 201.5c-.6-3.8-.6-7.5-.2-11.3 0-.5.2-.6.7-.5 5.3.5 10.7 1.1 16 1.6 3.4.3 6.8.6 10.3.9 4 .4 8.1.8 12.1 1.2l9.9.9c1.7.1 3.3.3 5 .4.3 0 .5.1.6.4l-8.4.9c-2.6.3-5.2.7-7.8 1-3.1.4-6.3.8-9.4 1.1-3.2.4-6.3.8-9.5 1.2-3.2.4-6.3.8-9.5 1.2-3.4.3-6.6.6-9.8 1z"
        />
        <path
          className="share-of-digital-shelf_st36"
          d="M304.7 195.7c-3.1 1-6.2 2.1-9.3 3.1-7.8 2.6-15.6 5.3-23.4 7.9-5.9 2-11.8 4-17.6 6-.5.2-1 .5-1.4-.1-.5-2.4-1.4-4.8-1.8-7.3-.1-1-.3-1.9-.5-2.9-.1-.4.1-.5.4-.5 2.3-.3 4.5-.6 6.8-.8l9.6-1.2c2.5-.3 4.9-.6 7.4-.9 3.3-.4 6.5-.8 9.8-1.2 3.1-.4 6.3-.7 9.4-1.1 3.2-.4 6.3-.8 9.5-1.2h1c.2 0 .2.1.1.2 0-.1 0 0 0 0z"
        />
        <path
          d="M304.7 195.7v-.2c.3-.3.7-.3 1 0-.3 0-.7.1-1 .2z"
          fill="#ded1ef"
        />
        <path
          className="share-of-digital-shelf_st7"
          d="M329 265.9h23.6v7.4H329zM468.8 248.6h14.4v7.4h-14.4z"
        />
        <path
          className="share-of-digital-shelf_st12"
          d="M221 221.8h19.5v7.4H221zM468.7 238h31.6v7.4h-31.6z"
        />
        <path
          className="share-of-digital-shelf_st36"
          d="M217.2 208.3h19.5v7.4h-19.5zM468.8 227.1h23.7v7.4h-23.7z"
        />
        <path
          className="share-of-digital-shelf_st35"
          d="M215.7 195.9h19.5v7.4h-19.5zM468.7 216.3h25.8v7.4h-25.8z"
        />
        <path
          className="share-of-digital-shelf_st11"
          d="M217.2 175.9h19.5v7.4h-19.5zM468.7 204.8h15.8v7.4h-15.8z"
        />
        <path
          className="share-of-digital-shelf_st10"
          d="M221.8 158.7h19.5v7.4h-19.5zM468.7 194h25.8v7.4h-25.8z"
        />
        <path
          className="share-of-digital-shelf_st9"
          d="M231.8 141h19.5v7.4h-19.5zM468.7 183.1h17.2v7.4h-17.2z"
        />
        <path
          className="share-of-digital-shelf_st8"
          d="M249 125.1h19.5v7.4H249zM468.7 172.3h14.4v7.4h-14.4z"
        />
        <path
          className="share-of-digital-shelf_st34"
          d="M275.1 115.2h19.5v7.4h-19.5zM468.7 161.4h23.7v7.4h-23.7z"
        />
        <path
          className="share-of-digital-shelf_st33"
          d="M336.5 119.8H356v7.4h-19.5zM468.7 150.5h19.5v7.4h-19.5z"
        />
        <path
          className="share-of-digital-shelf_st32"
          d="M373.2 157.1h23.7v7.4h-23.7zM468.7 139.7h23.7v7.4h-23.7z"
        />
      </g>
    </svg>
  )
}

export default ShareOfDigitalShelf
